'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'chart-diagram';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e695';
var svgPathData = ['M40 304l0 48 48 0 0-48c0-22.1 17.9-40 40-40l56 0 48 48 0 40 48 0 0-40 48-48 56 0c22.1 0 40 17.9 40 40l0 48 48 0 0-48c0-48.6-39.4-88-88-88l-56 0-48-48 0-40-48 0 0 40-48 48-56 0c-48.6 0-88 39.4-88 88z', 'M32 80c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L80 128c-26.5 0-48-21.5-48-48zm0 272l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm192 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm192 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChartDiagram = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;